import React from "react";
import EstoqueEmbalagemTopo from "./topo";
import EstoqueEmbalagensDetalhes from "./detalhe";

/* Localização */
/*
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
*/
import br from "date-fns/locale/pt-BR";
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import Parceiro from "../../components/classes/Parceiro";
import Utils from "../../helper/utils";

import styles from './detail.module.css';

export default function EstoqueEmbalagensPage() {
  var parceiro: Parceiro = JSON.parse(
    String(localStorage.getItem("ParceiroSelecionado"))
  );

  Utils.setDocumentTitle("Estoque BRF");

  return (
    <React.Fragment>
      <div className={`container ${styles.container}`}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
          <EstoqueEmbalagemTopo />
          <EstoqueEmbalagensDetalhes parceiro={parceiro}/>
        </LocalizationProvider>
      </div>
    </React.Fragment>
  );
}
